import { backendApi } from "@/services/api";
import type { SampleError } from "@/services/backend/sample-error/sample-error";

const sampleErrorApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    createError: build.mutation<SampleError, PutRequest>({
      query: (request) => ({
        url: `/sample-errors`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["SampleError"],
    }),
    listSampleErrors: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/sample-errors`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map(({ id }) => ({
                type: "SampleError" as const,
                id,
              })),
              { type: "SampleError", id: "LIST" },
            ]
          : [{ type: "SampleError", id: "LIST" }],
    }),
    deleteError: build.mutation<DeleteResponse, DeleteRequest>({
      query: (request) => ({
        url: `/sample-errors`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["SampleError"],
    }),
  }),
});

export const {
  useCreateErrorMutation,
  useListSampleErrorsQuery,
  useDeleteErrorMutation,
} = sampleErrorApi;

export interface PutRequest {
  sampleError: SampleError;
}

export interface ListRequest {}

export interface List {
  count: number;
  items: SampleError[];
}

export interface DeleteRequest {
  id: string;
}

export interface DeleteResponse {}
